import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  declare readonly menuTarget: HTMLElement

  private closeTimeout: number | null = null
  private isOpen = false

  connect() {
    // Ensure menu starts hidden
    this.menuTarget.classList.add("hidden")
  }

  show() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
    this.menuTarget.classList.remove("hidden")
    this.isOpen = true
  }

  scheduleHide() {
    // Delay hiding to allow mouse to move to dropdown
    this.closeTimeout = window.setTimeout(() => {
      this.hide()
    }, 150)
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    this.isOpen = false
  }

  keepOpen() {
    // Called when mouse enters the dropdown menu
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
  }

  navigate(event: Event) {
    // Allow the link to work normally - don't prevent default
    // The dropdown will close naturally when navigation happens
  }
}
